import { useWelcome } from 'lib/contexts/welcomeUserContext';

export const Welcome = () => {
  const welcomeUser = useWelcome();

  if (!welcomeUser) return null;

  const placeHolderAvatar = '/avatars/avatar-2.png';

  return (
    <div className="bg-hintgray p-4 rounded-lg max-w-2xl mb-4">
      <div className="mb-2 flex items-center">
        <img className="m-auto w-1/4 rounded-full" src={welcomeUser.avatarUrl || placeHolderAvatar} alt={welcomeUser.name} />
      </div>
      <h1 className="text-2xl font-bold text-center" data-testid="welcome">
        Welcome,
        {' '}
        {welcomeUser.name}
        !
      </h1>
    </div>
  );
};
